import { render, staticRenderFns } from "./PurchaseAndSaleMoney.vue?vue&type=template&id=25d705ac&scoped=true"
import script from "./PurchaseAndSaleMoney.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleMoney.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSaleMoney.vue?vue&type=style&index=0&id=25d705ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d705ac",
  null
  
)

export default component.exports